import React from "react";
import { connect } from 'react-redux';
import { Component } from "react";
import './device-inventory.component.css';
import { ListTab } from "../../../common/list-tab/list-tab.component";
import { VerticalTab } from "./vertical-tab.component";
import { ActiveSubscriber } from "./active-subscriber.component";
import { InputGroup, FormControl } from "react-bootstrap";
import Icons from "../../../icon";
import { Button } from 'react-bootstrap';
import Translation from "../../../common/translation/translation.component";
import { TRANSLATIONS as translation } from '../../../../utils/constant.utils';
import { LoadingText } from "../../../common/loading-text/loading-text-component";
import UserSearch from '../../../common/user-search/user-search.component';
import { DASHBOARD_MENU, DASHBOARD_TAB, USER_ROLES_ID } from '../../../../utils/constant.utils';
import { MAX_LENGTH, DISPLAY_ITEM } from "../../../../constants/external-constants";
import Avatar from "../../../common/avatar/Avatar";

class DeviceInventory extends Component {
    constructor(props) {
        super(props);
        this.state={
            isSearchAllAcct: false,
            toggleTab: DASHBOARD_TAB.MobileWireless,
            verticalToggleTab: "0",
            activeSubscriberEmployeeId: 0,
            curActiveSubscriberEmployeeId: 0,
            tabCount: 5,
            showNumberOfSubscribers: DISPLAY_ITEM.five,
            tabCountLine: 5,
            curCircuidId: 0,
            mobileSearchString: "",
            homeSearchString: "",
            MyDirectReportSearchedName: "",
            enterSearchValue: false,
            isPersonalTabVisited: false,
            isMyDirectReportTabVisited: false,
            autoSuggestSubscriber: [],
            userSearchHasValue: false,
            userSearchValue: "",
            hideAutoSuggestList: false,
            mobilePageIndex: 1,
            disableLoadMore: false
        }
        this.userSearch = null;
        this.clearUserSearch = this.clearUserSearch.bind(this);
        this.horizontalTab = this.horizontalTab.bind(this);
        this.setMyDashboardTab = this.setMyDashboardTab.bind(this);
        this.renderAllSubscribers = this.renderAllSubscribers.bind(this);
        this.onClickSubscriber = this.onClickSubscriber.bind(this);
        this.handleAutoSuggestClick = this.handleAutoSuggestClick.bind(this);
    }

    componentDidMount() {
        this.horizontalTab();
        this.activeSubscriberSelected();
        this.setMyDirectreportSearchAllAcct();
        this.handleAutoSuggestClick();
    }

    componentWillUnmount() {
        this.clearUserSearch();
    }

    componentDidUpdate() {
        const { activeMenu, selectedUser } = this.props;
        if (activeMenu === DASHBOARD_MENU.Personal && !this.state.isPersonalTabVisited) {
            this.setState({ userSearchValue: null })
            this.setMyDashboardTab(true, false);
        } else if (activeMenu === DASHBOARD_MENU.MyDirectReport && !this.state.isMyDirectReportTabVisited) {
            this.setState({ userSearchValue: null })
            this.setMyDashboardTab(false, true);
        }
        if (activeMenu === DASHBOARD_MENU.MyDirectReport && selectedUser !== undefined) {
            if (selectedUser.FullName !== this.state.MyDirectReportSearchedName) {
                this.setState({
                    MyDirectReportSearchedName: selectedUser.FullName,
                    tabCount: DISPLAY_ITEM.five
                });
            }  
        }
        this.verticalTabSelected();
        this.activeSubscriberSelected();
    }

    setMyDashboardTab(isPersonalTabVisited, isMyDirectReportTabVisited) {
        this.setState({
            isPersonalTabVisited: isPersonalTabVisited,
            isMyDirectReportTabVisited: isMyDirectReportTabVisited,
            toggleTab: DASHBOARD_TAB.MobileWireless,
            verticalToggleTab: "0",
            activeSubscriberEmployeeId: 0,
            curActiveSubscriberEmployeeId: 0,
            tabCount: 5,
            tabCountLine: 5,
            curCircuidId: 0,
            mobileSearchString: "",
            homeSearchString: "",
            MyDirectReportSearchedName: "",
            mobilePageIndex: 1,
            enterSearchValue: false,
        },() => {
            this.props.clearSelectedUser();
            this.horizontalTab();
            this.activeSubscriberSelected();
            this.setMyDirectreportSearchAllAcct();
        });  
    }
    
    setMyDirectreportSearchAllAcct() {
        const searchAllRoleIds = [USER_ROLES_ID.admin.toString()];
        var roleId = sessionStorage.UserRoleID; 
        var isAllowSearchAll = searchAllRoleIds.includes(roleId);
        if (isAllowSearchAll) {
            this.setState({
                isSearchAllAcct: true
            });
        }
    }

    horizontalTab(element) {
        var selectedTabIndex = DASHBOARD_TAB.MobileWireless;

        if(element)
        {
            const selectedTab = element.currentTarget.innerText.trim();
            const fixLineWirellineTab = this.toLocaleLanguage("home_landline").trim();
            if (fixLineWirellineTab.includes(selectedTab))
                selectedTabIndex = DASHBOARD_TAB.FixedLineWireLine;
        }

        if (!element || this.state.toggleTab !== selectedTabIndex) {
            this.setState({
                toggleTab: selectedTabIndex,
                tabCountLine: 5, 
                tabCount: 5
            });
            this.props.ontabSelected(selectedTabIndex);
            document.querySelectorAll(".tabActive").forEach(
                (el) => el.classList.remove("tabActive")
            );
            document.querySelectorAll(".inventory-tab .tab-list-container .list-tab").forEach((el) => {
                if(selectedTabIndex === el.attributes.getNamedItem("data-index").nodeValue) {
                    el.classList.add("tabActive");
                }
            });
            this.verticalTabSelected();
        }
    }

    verticalTabSelected() {
        const { activeCircuit } = this.props;
        const verticalList = document.querySelectorAll(".vertical-tab-item");
        for (let i = 0; verticalList.length > i; i++) {
            verticalList[i].classList.remove("vertical-tab-active");
            if (activeCircuit && parseInt(verticalList[i].getAttribute("data-index")) === activeCircuit.CircuitId) {
                verticalList[i].classList.add("vertical-tab-active");
            }
        }
    }

    onClickItem = (element) => {
        var verticalListActive = document.querySelectorAll(".vertical-tab-active");
        verticalListActive.forEach((el) => el.classList.remove("vertical-tab-active"));
        const circuitId = element.currentTarget.attributes.getNamedItem("data-index").nodeValue;
        this.setState({
            verticalToggleTab: circuitId,
        }, () => this.props.onActiveCiruitSelected(parseInt(circuitId)));
    }

    activeSubscriberSelected() {
         const verticalList = document.querySelectorAll(".active-subscriber-item");
         for (let i = 0; verticalList.length > i; i++) {
             verticalList[i].classList.remove("active-subscriber-active");
             if (verticalList[i].getAttribute("data-index") === this.state.curActiveSubscriberEmployeeId) {
                 verticalList[i].classList.add("active-subscriber-active");
             }
         }
    }

    onClickItemActiveSubscriber = (element) => {
        const employeeId = element.currentTarget.attributes.getNamedItem("data-index").nodeValue;
        
        if (this.state.curActiveSubscriberEmployeeId !== employeeId && this.state.activeSubscriberEmployeeId !== employeeId) {
            if (this.props.otherSubscribersList.find((y) => y.EmployeeId === parseInt(employeeId))) {
                var selectedUser = this.props.otherSubscribersList.find((y) => y.EmployeeId === parseInt(employeeId));
                this.props.setSelectedUser(selectedUser);     
            }
            document.querySelectorAll(".active-subscriber-active").forEach(
                (el) => el.classList.remove("active-subscriber-active"));
            this.setState({
                curActiveSubscriberEmployeeId: employeeId,
                activeSubscriberEmployeeId: employeeId
            }, () => {
                // this.props.clearActiveCircuit();
                // this.props.clearCircuitData();
                this.horizontalTab();
                this.activeSubscriberSelected();
            });
        }
    }

    async loadFunctionWireless() {
        this.setState({
            disableLoadMore: true
        })

        await this.props.fetchSubscriptionItems(true, 0, false);

        const { tabItem } = this.props;

        this.setState({
            tabCount: tabItem.Data.length
            , disableLoadMore: false
        })
    }

    async loadFunctionWireline() {
        this.setState({
            disableLoadMore: true
        })

       await this.props.fetchSubscriptionItems(false, 0, false);

        const { lineList } = this.props;

        this.setState({
            tabCountLine: lineList.Data.length
            , disableLoadMore: false
        })
    }

    verticalTabContent() {
        const { lineList, tabItem, planInfo, equipmentModel } = this.props; // Destructure props for better readability
        const items = this.state.toggleTab === DASHBOARD_TAB.MobileWireless ? tabItem : lineList;
        const count = this.state.toggleTab === DASHBOARD_TAB.MobileWireless ? this.state.tabCount : this.state.tabCountLine;

        return (
            <VerticalTab
                tabItem={items}
                tabCount={count}
                onClickItem={this.onClickItem.bind(this)}
                stringSearched={this.state.mobileSearchString}
                toggleTab={this.state.toggleTab}
                planInfo={planInfo}
                equipmentModel={equipmentModel}
            />
        );
    }

    ActiveSubscriberContent() {
        return (
            <ActiveSubscriber
                tabItem={this.props.tabItem}
                tabCount={this.state.tabCount}
                onClickItemActiveSubscriber={this.onClickItemActiveSubscriber.bind(this)}
                otherSubscribersList={this.props.otherSubscribersList}
            />
        );
    }

    handleSearchChange = async (e) => {
        var type = this.state.toggleTab === DASHBOARD_TAB.MobileWireless ? 'mobileSearchString' : 'homeSearchString';

        this.setState({
            [type]: e.target.value,
        }, () => {            
            if (e.target.value.trim() === '') {
                this.triggerSearch();
            }
        });          
    };

    triggerSearch = () => {
        const { triggerSearch } = this.props;
        var isMobile = this.state.toggleTab === DASHBOARD_TAB.MobileWireless ? true : false;
        triggerSearch(isMobile, isMobile ? this.state.mobileSearchString : this.state.homeSearchString);
        this.setState({
            enterSearchValue: true,
        });
    };


    renderCurrentSelectedUserDetails = () => {
        const { selectedUser } = this.props;
        return (
            selectedUser === undefined ? "" : selectedUser.FullName !== "" ?
            <div className="current-selected-user-container">
                    <div className="showing-info-for">
                        <p className="string-result-style"><Translation translationKey="showing_information_for" /></p>
                </div>
                    <div className="active-subscriber-container active-subscriber-item current-selected-user mb-4 subscriber-search-result">
                        
                        <Button className="clear-user-button" onClick={this.clearUserSearch}>
                            x
                        </Button>
                        <div className="tab-client-logo">
                            
                            <Avatar className="tab-client-logo subscriber-logo" src="" text={selectedUser.FullName} />                         
                        </div>
                        <div className="tab-details">
                            <h1 className="tab-details-phonenumber">{selectedUser.FullName}</h1>
                            <h2 className="tab-details-office">{selectedUser.EId}</h2>
                            <h2 className="tab-details-office">{selectedUser.Location}</h2>
                        </div>
                       
                </div>
            </div> : ""
        );
    };

    renderAllSubscribers = () => {
        const { subscriberDataList } = this.props;
        var showNumberOfSubscribers = this.state.showNumberOfSubscribers < subscriberDataList.length ? this.state.showNumberOfSubscribers : subscriberDataList.length;
        return (
            Array.isArray(subscriberDataList)
                ? subscriberDataList?.slice(0, showNumberOfSubscribers).map(subscriber => 
                <div className="current-selected-user-container" onClick={() => this.onClickSubscriber(subscriber)}>
                        <div className="active-subscriber-container active-subscriber-item current-selected-user mb-4">
                        <div className="tab-client-logo">

                            <Avatar className="tab-client-logo subscriber-logo" src="" text={subscriber.Name} />           
                        </div>
                            <div className="tab-details">
                                <h1 className="tab-details-phonenumber">{subscriber.Name}</h1>
                                <h2 className="tab-details-office">{subscriber.Eid}</h2>
                            <h2 className="tab-details-office">{subscriber.LocationSiteCityCountry}</h2>
                            </div>                           
                    </div>
                </div>)
            : null
        );
    };

    handleLoadSubscribers = async () => {
        this.setState({
            disableLoadMore: true
        })
        await this.props.fetchAllSubscribersViewMore()

        const { subscriberDataList } = this.props;
        this.setState(prev => ({
                ...prev,
            showNumberOfSubscribers: prev.showNumberOfSubscribers < subscriberDataList.length ? prev.showNumberOfSubscribers + DISPLAY_ITEM.five : DISPLAY_ITEM.five
            , disableLoadMore: false
            })
        )
    }

    clearUserSearch = () => {
        const { activeMenu, clearSelectedUser, clearCircuitData, clearActiveCircuit, clearSubscriptionItems } = this.props;
        if (activeMenu === DASHBOARD_MENU.MyDirectReport) {
            this.userSearch.clearField();
        }
        clearSelectedUser();
        clearCircuitData();
        clearActiveCircuit();
        clearSubscriptionItems(true);
        clearSubscriptionItems(false);
        this.clearSearch(true);
        this.clearSearch(false);
        this.setState({
            activeSubscriberEmployeeId: 0,
            curActiveSubscriberEmployeeId: 0,
            tabCount: DISPLAY_ITEM.five
        });
    };

    clearSearch = () => {
        var isMobile = this.state.toggleTab === DASHBOARD_TAB.MobileWireless ? true : false;
        var type = isMobile ? 'mobileSearchString' : 'homeSearchString';
        this.setState({
            [type]: '',
        });

        if (this.state.enterSearchValue) {
            this.props.clearSearchField(isMobile);
            this.setState({
                enterSearchValue: false,
            });
        }
    };
    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    };

    onClickAutoSuggestion = async (item) => {
        if (item.EmployeeId !== this.state.activeSubscriberEmployeeId)
        {
            this.props.clearActiveCircuit();
            await this.props.setSelectedUser(item);
            this.setState({
                toggleTab: DASHBOARD_TAB.MobileWireless,
                activeSubscriberEmployeeId: item.EmployeeId,
                curActiveSubscriberEmployeeId: item.EmployeeId,
            }, () => {
                this.horizontalTab();
            });
        }
    }

    onClickSubscriber = async (subscriber) => {
        if (subscriber.EmployeeId !== this.state.activeSubscriberEmployeeId)
        {
            this.props.clearActiveCircuit();
            await this.props.setSelectedUser({
                EmployeeId: subscriber.EmployeeId,
                EId: subscriber.Eid,
                FullName: subscriber.Name,
                Location: subscriber.LocationSiteCityCountry
            });
            this.setState({
                toggleTab: DASHBOARD_TAB.MobileWireless,
                activeSubscriberEmployeeId: subscriber.EmployeeId,
                curActiveSubscriberEmployeeId: subscriber.EmployeeId,
                showNumberOfSubscribers: DISPLAY_ITEM.five,
            }, () => {
                this.horizontalTab();
            });
        }
    }

    async handleAutoSuggestClick(value) {
        const { allSubscribers } = this.props;

        await this.props.fetchAllSubscribers(value, 1);
        var searchSubscriber = allSubscribers;

        this.setState({autoSuggestSubscriber: value?.trim().length > 0 ? searchSubscriber : []});
        this.setState({userSearchHasValue: searchSubscriber?.length > 0 || value == null ? true : false});
        this.setState({ userSearchValue: value })

        return searchSubscriber;
    }

    loadMoreAutosuggest = async (searchString) => {
        
        await this.props.fetchAllSubscribers(searchString, this.props.subscriberListPage + 1);

        const { allSubscribers } = this.props;

        return allSubscribers ?? [];
    }

    searchAutosuggest = async (searchString) => {

        await this.props.fetchAllSubscribers(searchString, 1);

        const { allSubscribers } = this.props;

        return allSubscribers ?? [];

    }

    render() {
        const { tabItem, lineList, activeMenu, verticaltabItem, subscriberDataList, hasMoreCircuitView } = this.props;
        
        return (
            <div className="inventory-wrapper">
                <div className="inventory-container">
                    <h1 className="inventory-title"><Translation translationKey="subscription_and_device_inventory" /></h1><br />
                    {activeMenu === DASHBOARD_MENU.MyDirectReport ?
                        <div>
                            <UserSearch 
                                ref={(userSearch) => (this.userSearch = userSearch)}
                                list={[]}
                                action={this.onClickAutoSuggestion.bind(this)}
                                onDemandAction={this.handleAutoSuggestClick}
                                maxLength={MAX_LENGTH.limit_100}
                                loadMoreAutosuggest={this.loadMoreAutosuggest}
                                allSubscribers={this.props.allSubscribers}
                                searchAutosuggest={this.searchAutosuggest}
                            />
                            <div className={`search-field ${(tabItem.Data.length > DISPLAY_ITEM.seven) ? "scroll-active-pd-right" : ""} ${(this.state.showNumberOfSubscribers > DISPLAY_ITEM.six) ? "scroll-active-pd-right" : ""}`}>
                            {this.state.userSearchHasValue || this.state.userSearchValue == null ? 
                                this.props.selectedUser.EmployeeId ? this.renderCurrentSelectedUserDetails() : this.renderAllSubscribers() 
                            : <h1 className="active-subscriber-label"><Translation translationKey="no_results_found_for" /> "{this.state.userSearchValue}" </h1> }
                            {this.state.userSearchHasValue || this.state.userSearchValue == null ? 
                                    (!this.props.selectedUser.EmployeeId && this.props.hasMoreSubscriberView) &&
                                    <Button variant="outline-secondary" disabled={this.state.disableLoadMore} className="load-button" onClick={this.handleLoadSubscribers.bind(this)}>
                                         < Translation translationKey="load_more" />
                                    </Button>
                                : null
                            }
                            </div>
                            {this.state.activeSubscriberEmployeeId > 0 ?
                                <div>
                                    {verticaltabItem && <ListTab containerClassName="inventory-tab" tabList={verticaltabItem} clickAction={this.horizontalTab }/>}
                                    <InputGroup size="sm" className="mb-3 request-input-header">
                                        <InputGroup.Text id="inputGroup-sizing-sm">
                                            <Icons name="search" customClassName="icon-search" size="12px" />
                                        </InputGroup.Text>
                                        <FormControl
                                            disabled={false}
                                            placeholder={this.toLocaleLanguage('search_circuit')}
                                            maxLength={MAX_LENGTH.limit_100}
                                            aria-label="Small"
                                            aria-describedby="inputGroup-sizing-sm"
                                            onChange={(e) => this.handleSearchChange(e)}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    this.triggerSearch();
                                                }
                                            }}
                                            value={this.state.toggleTab === DASHBOARD_TAB.MobileWireless ? this.state.mobileSearchString : this.state.homeSearchString}
                                        />
                                        {this.state.toggleTab === DASHBOARD_TAB.MobileWireless ? this.state.mobileSearchString !== "" ? <Icons name="circle-close-duo" customClassName="icon-clear" onClick={this.clearSearch} size="12px" /> : ""
                                        : this.state.homeSearchString !== "" ? <Icons name="circle-close-duo" customClassName="icon-clear" onClick={this.clearSearch} size="12px" /> : ""
                                    }
                                    </InputGroup>
                                    <div className="search-field scroll-active-pd-right"> 
                                    {this.verticalTabContent()}
                                    {this.state.toggleTab === DASHBOARD_TAB.MobileWireless ?
                                            tabItem !== undefined ? tabItem.Data === undefined
                                                ? <LoadingText loadingLabel="Loading" />
                                                : (tabItem.isFetching !== true && hasMoreCircuitView) &&
                                            <Button variant="outline-secondary" disabled={this.state.disableLoadMore} className="load-button" onClick={this.loadFunctionWireless.bind(this)}>
                                                   < Translation translationKey="load_more" /> 
                                                </Button>
                                                : <LoadingText loadingLabel="Loading" />
                                            :
                                            lineList !== undefined ? lineList.Data === undefined
                                                ? <LoadingText loadingLabel="Loading" />
                                                : (!lineList.isFetching && hasMoreCircuitView) &&
                                            <Button variant="outline-secondary" disabled={this.state.disableLoadMore} className="load-button" onClick={this.loadFunctionWireline.bind(this)}>
                                                       < Translation translationKey="load_more" /> </Button>
                                                 : <LoadingText loadingLabel="Loading" />
                                        } </div>
                                </div> : subscriberDataList.length === 0 ?
                                    this.userSearch?.state.value === "" ? 
                                        this.props.isLoadingSubscriber ?
                                        <h1 className="active-subscriber-label"><Translation translationKey="loading_active_subscribers"/></h1> :
                                        <h1 className="active-subscriber-label"><Translation translationKey="no_active_subscribers" /></h1> :
                                        <h1 className="active-subscriber-label"><Translation translationKey="no_results_found_for" /> "{this.userSearch?.state.value}" </h1> : ""
                                }                              
                        </div> : ""}
                    {activeMenu === DASHBOARD_MENU.Personal ?
                        <div>
                            {verticaltabItem && <ListTab containerClassName="inventory-tab" tabList={verticaltabItem} clickAction={this.horizontalTab} />}
                            <InputGroup size="sm" className="mb-3 request-input-header">
                                <InputGroup.Text id="inputGroup-sizing-sm">
                                    <Icons name="search" customClassName="icon-search" size="12px" />
                                </InputGroup.Text>
                                <FormControl
                                    disabled={false}
                                    placeholder={this.toLocaleLanguage('search_circuit')}
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                    onChange={(e) => this.handleSearchChange(e)}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            this.triggerSearch();
                                        }
                                    }}
                                    maxLength={100}
                                    value={this.state.toggleTab === DASHBOARD_TAB.MobileWireless ? this.state.mobileSearchString : this.state.homeSearchString}
                                />
                                {this.state.toggleTab === DASHBOARD_TAB.MobileWireless ? this.state.mobileSearchString !== "" ? <Icons name="circle-close-duo" customClassName="icon-clear" onClick={this.clearSearch} size="12px" /> : ""
                                    : this.state.homeSearchString !== "" ? <Icons name="circle-close-duo" customClassName="icon-clear" onClick={this.clearSearch} size="12px" /> : ""
                                }
                            </InputGroup>
                            <div className={`subscription-scroll-box ${(this.state.tabCount && (this.state.tabCount > 7 || this.state.tabCountLine > 7)) ? "scroll-active-pd-right" : ""}`}>
                            {this.verticalTabContent()}
                                {this.state.toggleTab === DASHBOARD_TAB.MobileWireless ? (
                                    tabItem ? (
                                        tabItem.Data ? (
                                            (!tabItem.isFetching && hasMoreCircuitView) && (
                                                <Button
                                                    variant="outline-secondary"
                                                    className="load-button"
                                                    onClick={this.loadFunctionWireless.bind(this)}
                                                    disabled={this.state.disableLoadMore}
                                                >
                                                    <Translation translationKey="load_more" />
                                                </Button>
                                            )
                                        ) : (
                                            <LoadingText loadingLabel="Loading" />
                                        )
                                    ) : (
                                        <LoadingText loadingLabel="Loading" />
                                    )
                                ) : lineList ? (
                                        (!lineList.isFetching && hasMoreCircuitView) && (
                                        <Button
                                            variant="outline-secondary"
                                            className="load-button"
                                            onClick={this.loadFunctionWireline.bind(this)}
                                            disabled={this.state.disableLoadMore}
                                        >
                                            <Translation translationKey="load_more" />
                                        </Button>
                                    )
                                ) : (
                                    <LoadingText loadingLabel="Loading" />
                                )}

                            </div>
                        </div> : ""
                    }
                 </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { translation } = state;
    return {
        ...translation,
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(DeviceInventory);